'use strict';

/**
 * Label resolver for the Drafting Kit language layer. The one helper every view
 * calls instead of hardcoding entity nouns. Reads the resolved lexicon off the
 * session (AppData.Auth.User.Lexicon, the plan sheet's default-kit terms), with
 * an optional per-vision scope override and Terms.DEFAULT_TERMS as the floor.
 *
 * Resolution order (first hit wins): pScopeTerms -> shell lexicon -> defaults ->
 * caller fallback -> the key itself. EntityDescriptors is NOT mutated; it stays
 * the canonical fallback (callers pass descriptor labels as pFallback for keys
 * that have no term, e.g. KeystoneCustomer).
 */

const libTerms = require('./Terms.js');

function _shellLexicon(pPict)
{
	return (pPict && pPict.AppData && pPict.AppData.Auth && pPict.AppData.Auth.User && pPict.AppData.Auth.User.Lexicon) || null;
}

function _pick(pField, pPict, pKey, pScopeTerms, pFallback)
{
	if (pScopeTerms && pScopeTerms[pKey] && pScopeTerms[pKey][pField]) { return pScopeTerms[pKey][pField]; }
	let tmpShell = _shellLexicon(pPict);
	if (tmpShell && tmpShell[pKey] && tmpShell[pKey][pField]) { return tmpShell[pKey][pField]; }
	if (libTerms.DEFAULT_TERMS[pKey] && libTerms.DEFAULT_TERMS[pKey][pField]) { return libTerms.DEFAULT_TERMS[pKey][pField]; }
	return (pFallback != null) ? pFallback : pKey;
}

// The plural / heading form (e.g. "Modules" or "Collections").
function plural(pPict, pKey, pScopeTerms, pFallback) { return _pick('Plural', pPict, pKey, pScopeTerms, pFallback); }
// The singular form (e.g. "Module" or "Collection").
function singular(pPict, pKey, pScopeTerms, pFallback) { return _pick('Singular', pPict, pKey, pScopeTerms, pFallback); }
// The list-page / section heading; today the plural.
function title(pPict, pKey, pScopeTerms, pFallback) { return plural(pPict, pKey, pScopeTerms, pFallback); }
// The secondary descriptive blurb (e.g. under a nav item or list heading).
function description(pPict, pKey, pScopeTerms, pFallback) { return _pick('Description', pPict, pKey, pScopeTerms, pFallback); }

module.exports =
{
	plural: plural,
	singular: singular,
	title: title,
	description: description
};
